import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Card,
  Grid,
  Avatar,
  Checkbox,
  FormGroup,
  Typography,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import CategoryIcon from '@material-ui/icons/Category';
import { ideaActions } from "../../../actions";
import { IdeaCss } from '../IdeaCss';

export function IdeaCategory() {
  const { id } = useParams();
  const classes = IdeaCss();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {selectedCategories} = useSelector(state => state.fluxIdeas);

  function handleChangeCategory(event) {
    const { name, checked } = event.target;
    dispatch(ideaActions.changeCategory({_id: name, checked }));

    const selected = selectedCategories
      .map(item => {
        if (item._id === name) {
          return { ...item, checked };
        }
        return item;
      })
      .filter(item => item.checked)
      .map(item => item._id);

    const hasFilter = selected.length > 0 ? selected : [];
    
    dispatch(ideaActions.updateIdeaCategories(id, hasFilter));
  }

  return (
    <Grid item xs={12}>
      <Card elevation={0} className={classes.card}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Avatar className={classes.avatarIcon}>
                <CategoryIcon color="primary" fontSize="small" />
              </Avatar>
              <Typography variant="subtitle1">{t('defina_a_categoria_do_case')}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormGroup className={classes.formGroup}>
                {selectedCategories.map(item => (
                  <FormControlLabel
                    key={item._id}
                    label={item.label}
                    control={
                      <Checkbox
                        color="primary"
                        name={item._id}
                        checked={item.checked}
                        onChange={handleChangeCategory}
                      />
                    }
                  />
                ))}
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}